import { toast as sonnerToast } from 'sonner';
import { normalizeFeedbackError } from './feedbackMessages';

const COPY_REWRITES = [
  [/fortress level clearance/gi, 'administrator access'],
  [/identity authority/gi, 'verification'],
  [/surgical strike/gi, 'content update'],
  [/surgical mode/gi, 'content review'],
  [/ghosted/gi, 'hidden'],
  [/hard scan/gi, 'report refresh'],
  [/transmission/gi, 'message'],
  [/tactical error/gi, 'unexpected error'],
  [/hardware enclave/gi, 'device security'],
  [/identity revoked/gi, 'session expired'],
  [/violation detected/gi, 'content needs review'],
  [/encrypted & stored/gi, 'Encrypted and saved'],
  [/clipboard purged/gi, 'Clipboard cleared'],
  [/key restored!/gi, 'Recovery key restored'],
  [/profile created seamlessly!/gi, 'Profile created'],
  [/welcome to linkit!/gi, 'Welcome to Linkit'],
  [/order synced!/gi, 'Order saved'],
  [/link added!/gi, 'Link added'],
  [/image optimized & loaded!/gi, 'Image optimized and loaded'],
  [/avatar updated!/gi, 'Avatar updated'],
  [/background set!/gi, 'Background updated'],
  [/fresh link sent!/gi, 'New link sent'],
];

const TECHNICAL_ERROR_RE =
  /sqlstate|constraint|stack|status:\s*\d|http\s*\d|supabase|postgres|fetch failed|failed to fetch|networkerror|unexpected token|undefined|null reference|rls|jwt|pgrst|diag:/i;

const cleanCopy = (value) => {
  if (typeof value !== 'string') return value;
  let next = value.replace(/[\u{1F300}-\u{1FAFF}\u2600-\u27BF]/gu, '').replace(/\s{2,}/g, ' ').trim();
  COPY_REWRITES.forEach(([pattern, replacement]) => {
    next = next.replace(pattern, replacement);
  });
  return next;
};

const cleanOptions = (options = {}) => ({
  ...options,
  description: cleanCopy(options.description),
});

const showError = (error, options = {}) => {
  const raw = error instanceof Error ? error.message : String(error || '');
  if (error instanceof Error || TECHNICAL_ERROR_RE.test(raw)) {
    const normalized = normalizeFeedbackError(error, {
      title: options.title,
      description: options.description,
    });
    if (import.meta.env.DEV) {
      console.error(`[${normalized.reference}]`, normalized.technicalMessage, error);
    }
    return sonnerToast.error(normalized.title, {
      ...cleanOptions(options),
      description: `${normalized.description} Reference: ${normalized.reference}`,
    });
  }

  return sonnerToast.error(cleanCopy(raw) || 'Could not complete this action', cleanOptions(options));
};

const toast = (...args) => sonnerToast(...args);

toast.success = (message, options) => sonnerToast.success(cleanCopy(message), cleanOptions(options));
toast.info = (message, options) => sonnerToast.info(cleanCopy(message), cleanOptions(options));
toast.warning = (message, options) => sonnerToast.warning(cleanCopy(message), cleanOptions(options));
toast.error = showError;
toast.loading = (message, options) => sonnerToast.loading(cleanCopy(message), cleanOptions(options));
toast.dismiss = (...args) => sonnerToast.dismiss(...args);
toast.promise = (...args) => sonnerToast.promise(...args);
toast.custom = (...args) => sonnerToast.custom(...args);

export { toast };
